import { render, staticRenderFns } from "./DiscountDetail.vue?vue&type=template&id=c3d03052&scoped=true&"
import script from "./DiscountDetail.vue?vue&type=script&lang=js&"
export * from "./DiscountDetail.vue?vue&type=script&lang=js&"
import style0 from "./DiscountDetail.vue?vue&type=style&index=0&id=c3d03052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d03052",
  null
  
)

export default component.exports